import { useLocation, useHistory } from 'react-router-dom';
import { useEffect } from 'react';
import { useLocalStorage } from '../../services/hooks/useLocalStorage';
import { STC_ID, STRATUS_ID } from '../../services/constants';
import Header from '../Header';
import Loading from '../Loading';

import {
    getMFPUserSettings
} from '../../services/api';

const NoDipa = () => {
    const history = useHistory();
    const location = useLocation();
    const [_noDipa, setNoDipa] = useLocalStorage("noDipa", false);
    const [_stratus, setStratus] = useLocalStorage("stratus", false);
    const [_appVersion, setAppVersion] = useLocalStorage('appVersion', '')
    const [_generation, setGeneration] = useLocalStorage('generation', -1)
    const [_loggedInFromAuth, setLoggedInFromAuth] = useLocalStorage('loggedInFromAuth', false);
    // Used for clearing session
    const [_user, setUser] = useLocalStorage('user', '');
    const [_tenant, setTenant] = useLocalStorage('tenant', undefined);
    const [_accessToken, setAccessToken] = useLocalStorage('accessToken', undefined);
    const [_idToken, setIdToken] = useLocalStorage('idToken', undefined);
    const [_refreshToken, setRefreshToken] = useLocalStorage('refreshToken', undefined);
    const [_client, setClient] = useLocalStorage('client', undefined);
    const [_sqta, setSqta] = useLocalStorage('dipa-sqta', '');
    const [_hasScanner, setHasScanner] = useLocalStorage('hasScanner', true);
    const [_hash, setHash] = useLocalStorage('hash', '');
    const [_hashCacheVersion, setHashCacheVersion] = useLocalStorage('hashCacheVersion', '');

    async function loadSettingsFromMfp(stratus) {
        let appId = STC_ID;
        if (stratus) {
            appId = STRATUS_ID;
        }
        const settings = await getMFPUserSettings(appId);
        return settings
    }

    async function setSettings(settings) {
        if (settings?.userData?.refreshToken) {
            setRefreshToken(settings?.userData?.refreshToken);
        }
        if (settings?.userData?.client) {
            setClient(settings?.userData?.client);
        }
        if (settings?.userData?.tenant) {
            setTenant(settings?.userData?.tenant);
        }
        if (settings?.userData?.idToken) {
            setIdToken(settings?.userData?.idToken);
        }
        if (settings?.userData?.accessToken) {
            setAccessToken(settings?.userData?.accessToken);
        }
        if (settings?.userData?.user) {
            setUser(settings?.userData?.user);
        }
    }

    useEffect(() => {
        const sessionCheck = async () => {
            setNoDipa(true);
            const params = new URLSearchParams(location.search);
            const isStratusPresent = params.get("stratus");
            const hash = params.get('did');
            const hasScanner = params.get('scanner');
            if (isStratusPresent) {
                setStratus(true);
            } else {
                // If both STC and Stratus are installed, this will help switch between both of them
                setStratus(false);
            }
            const version = params.get("version");
            if (version) {
                setAppVersion(version)
            }
            if (hasScanner) {
                setHasScanner(JSON.parse(hasScanner))
            }
            if (hash) {
                const cacheHashComparer = '2025-10-01';
                setHash(hash);
                setHashCacheVersion(cacheHashComparer);
            }
            const generation = params.get("generation");
            if (generation) {
                setGeneration(parseInt(generation));
            }
            const keepLoggedInParam = params.get("keepLoggedIn");
            const keepLoggedIn = keepLoggedInParam !== null && keepLoggedInParam !== "false";
            const authpresent = params.get("authpresent");
            const loggedInFromAuth = authpresent !== null && authpresent !== "false";
            setLoggedInFromAuth(loggedInFromAuth);
            const publicUserParam = params.get("publicuser");
            const publicUser = (publicUserParam !== null && publicUserParam !== "false");
            setTenant(undefined);
            setUser('');
            setAccessToken(undefined);
            setIdToken(undefined);
            setRefreshToken(undefined);
            setClient(undefined);
            if (!keepLoggedIn && !(loggedInFromAuth && !publicUser)) {
                setSqta('');
                history.push('/');
            } else {
                const settings = await loadSettingsFromMfp(isStratusPresent);
                await setSettings(settings);
                history.push('/');
            }
        }
        sessionCheck();
        // eslint-disable-next-line
    }, []);

    return (
        <>
            <Header />
            <Loading />
        </>
    )
}

export default NoDipa